import { ButtonVariants } from '..'
import { ArrowLeftIcon } from '../../icons'
import React, { ReactElement } from 'react'
import { LinkAsButton, LinkAsButtonProps } from './LinkAsButton'

interface Props extends Omit<LinkAsButtonProps, 'variant' | 'icon'> {}

export const LinkAsBackButton = ({ ...props }: Props): ReactElement => (
    <LinkAsButton data-testid="back-button" variant={ButtonVariants.QUIET} icon={<ArrowLeftIcon />} {...props} />
)
